<template>
	<div class="return-photo" v-loading="loading">
		<div class="filter">
			<gc-custom-search
				class="search"
				width="300px"
				key-word="拍照类型"
				type="select"
				needAllForSearch
				:search.sync="params.photoTriggerType"
				:search-option="photoTypeOptions"
			></gc-custom-search>
			<gc-custom-search
				class="search"
				width="500px"
				key-word="拍照时间"
				type="date"
				date-picker-type="datetimerange"
				:search.sync="params.first"
			>
				<template v-slot:icon>
					<i class="iconfont icon-riqi"></i>
				</template>
			</gc-custom-search>
			<el-button v-click-blur type="primary" class="query" @click="query">查 询</el-button>
			<el-button v-click-blur @click="reset">重 置</el-button>
		</div>
		<div class="table">
			<gc-table
				ref="returnPhotoTable"
				border
				showPage
				:columns="columns"
				:table-data="tableData"
				:total="total"
				:current-page.sync="currentPage"
				:page-size="params.size"
				@size-change="handleSizeChange"
				@current-page-change="pageChange"
			></gc-table>
		</div>
	</div>
</template>

<script>
import { apiGetBrsPhotoRecordPage } from '@/apis/account.api'

export default {
	name: 'ReturnPhoto',
	props: {
		curTabName: String,
	},
	data() {
		return {
			loading: false,
			total: 0,
			currentPage: 1,
			tableData: [],
			params: {
				first: null,
				photoTriggerType: null,
				current: 1,
				deviceId: null,
				size: 20,
			},
			photoTypeOptions: [
				{
					label: '手动拍照',
					value: 3,
				},
				{
					label: '定时拍照',
					value: 4,
				},
			],
		}
	},
	computed: {
		columns() {
			return [
				{
					key: 'photoId',
					name: '图片ID',
					width: 180,
				},
				{
					key: 'eventTime',
					name: '拍照时间',
					width: 180,
				},
				{
					key: 'photoType',
					name: '拍照类型',
					width: 140,
				},
				{
					key: 'detail',
					name: '详情',
					tooltip: true,
				},
				{
					key: 'imageUrlList',
					name: '回传照片',
					minWidth: 180,
					render: (h, row) => {
						const imageUrlList = row.imageUrlList || []
						if (!imageUrlList.length) return h('span', {}, '--')
						return h(
							'div',
							{
								style: {
									display: 'flex',
									'flex-wrap': 'wrap',
									gap: '6px',
									padding: '4px 0',
								},
							},
							imageUrlList.map((url, index) =>
								h('el-image', {
									key: `${row.id || row.photoId}-${index}`,
									style: {
										width: '40px',
										height: '40px',
										'border-radius': '4px',
										cursor: 'pointer',
										background: '#f5f7fa',
									},
									props: {
										src: url,
										fit: 'cover',
										previewSrcList: imageUrlList,
										initialIndex: index,
									},
								}),
							),
						)
					},
				},
			]
		},
	},
	watch: {
		curTabName: {
			immediate: true,
			handler(val) {
				if (val === 'ReturnPhoto' && !this.tableData.length) {
					this.reset()
				}
			},
		},
	},
	methods: {
		handleSizeChange(size) {
			this.params.size = size
			this.getPhotoRecordList(1)
		},
		getPhotoRecordList(page) {
			this.loading = true
			this.params.current = page
			this.params.deviceId = this.$attrs.common
			apiGetBrsPhotoRecordPage(this.getRequestParams())
				.then(res => {
					this.tableData = res.records || []
					this.total = res.total || 0
					this.currentPage = res.current || page
				})
				.catch(() => {})
				.finally(() => {
					this.loading = false
				})
		},
		getRequestParams() {
			const obj = {}
			for (var key in this.params) {
				const val = this.params[key]
				if (val || val === 0) {
					if (key === 'first') {
						obj.startTime = this.dayjs(val[0]).format('YYYY-MM-DD HH:mm:ss')
						obj.endTime = this.dayjs(val[1]).format('YYYY-MM-DD HH:mm:ss')
					} else {
						obj[key] = val
					}
				}
			}
			return obj
		},
		query() {
			this.getPhotoRecordList(1)
		},
		reset() {
			this.params.first = null
			this.params.photoTriggerType = null
			this.query()
		},
		pageChange(page) {
			this.getPhotoRecordList(page)
		},
	},
}
</script>

<style lang="scss" scoped>
.return-photo {
	@include base-button(80px);
	display: flex;
	flex-direction: column;
	padding: 0 24px;
	height: 100%;
	.filter {
		display: flex;
		justify-content: flex-start;
		align-items: center;
		margin: 20px 0 24px;
		.query {
			margin-left: 20px;
		}
		.search {
			margin-right: 20px;
		}
	}
	.table {
		flex: 1;
		height: 0;
	}
}
</style>
